// extracted by mini-css-extract-plugin
export var formContainer = "_hw-0";
export var message = "_hw-1";